import "../../App.css";
import React from "react";
import ROOT_CANEL from '../Root_Canel';
import CONTACT_US from '../footer';
import Accordian from '../../accordian/accordian'
import ScrollArrow from '../ScrollUp';
import BackBtn from '../BackBtn';
function ROOT_CANEL__Page() {
    return(
    <> 
        <ROOT_CANEL/>
        <Accordian
         title=" Is root canal painful" 
         content="It isn't as difficult as it might appear. On many occasions, individuals continue postponing the visit to the dental specialist, which causes an extreme disease. You will be given anaesthesia before the procedure which may feel like a typical dental filling."
       />
       <Accordian
         title=" Can I go back to work after my root canal" 
         content="  Truly you can. You will be numb for 2-3 hours after your treatment, you might not eat until the point when the resistance is no more. You may unconsciously nibble your lip or cheek."
       />
       <Accordian
         title=" How long does a root canal take" 
         content=" The measure of time relies upon the subtle elements of the strategy you're having and the sort of tooth included. It may last around 1-2 hours, the treatment itself can frequently be finished in one visit. On occasion, a second shift might be required."
         />
         <Accordian
         title=" Is root canal expensive" 
         content="     Sparing your tooth through endodontic treatment is more affordable and less invasive than an extraction and replacement of a tooth. Cost will rely upon your dental protection inclusion. The dental specialist helps with getting your detailed insight and let you know the expense of your root canal." />
         <BackBtn/>
         <CONTACT_US/>
         <ScrollArrow/>

    </>
    )
}
export default ROOT_CANEL__Page;